import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { REGISTER_AS_ERRORS } from 'components/register-as/register-as.constants';
import { EntryService } from 'services/entry/entry.service';
import { SIGN_UP_TYPES } from 'pages/entry/entry.helpers';
import { SmartForm } from '@certemy/ui-components';

@Component({
  selector: 'cm-self-enrollment-registration',
  templateUrl: './self-enrollment-registration.component.html',
  styleUrls: ['./self-enrollment-registration.component.scss'],
})
export class SelfEnrollmentRegistrationComponent implements OnInit {
  @Input() organizationRoles: SmartForm.FieldOption[];

  token;
  title;
  readonly SIGN_UP_TYPES = SIGN_UP_TYPES;
  constructor(private router: Router, private route: ActivatedRoute, private entryService: EntryService) {}

  ngOnInit() {
    this.token = this.route.snapshot.params['token'];
    this.title = this.route.snapshot.params['title'];
  }

  handleRegisterAsResponse(data) {
    if (data.success) {
      this.entryService.setMessageType(data.message);
      this.router.navigate(['/entry/message']);
    } else {
      switch (data.error) {
        case REGISTER_AS_ERRORS.USER_DELETED:
          this.entryService.setMessageType(data.message);
          this.router.navigate(['/entry/message']);
          break;

        case REGISTER_AS_ERRORS.EXISTING_ACCOUNT:
          this.entryService.setMessageType(data.message);
          this.router.navigate(['/entry/existing-account']);
          break;

        case REGISTER_AS_ERRORS.LINK_NOT_FOUND:
          this.router.navigateByUrl('/not-found');
          break;

        default:
          this.router.navigateByUrl('/entry/login');
      }
    }
  }
}
